/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ConfiguredMessage } from '../models/configured-message';
import { ConfiguredMessageListPaged } from '../models/configured-message-list-paged';
import { createConfiguredMessage } from '../fn/information-messages/create-configured-message';
import { CreateConfiguredMessage$Params } from '../fn/information-messages/create-configured-message';
import { createNews } from '../fn/information-messages/create-news';
import { CreateNews$Params } from '../fn/information-messages/create-news';
import { deleteConfiguredMessage } from '../fn/information-messages/delete-configured-message';
import { DeleteConfiguredMessage$Params } from '../fn/information-messages/delete-configured-message';
import { deleteNews } from '../fn/information-messages/delete-news';
import { DeleteNews$Params } from '../fn/information-messages/delete-news';
import { GeneratedNote } from '../models/generated-note';
import { GeneratedNotePagedListAdmin } from '../models/generated-note-paged-list-admin';
import { getConfiguredMessage } from '../fn/information-messages/get-configured-message';
import { GetConfiguredMessage$Params } from '../fn/information-messages/get-configured-message';
import { getGeneratedNote } from '../fn/information-messages/get-generated-note';
import { GetGeneratedNote$Params } from '../fn/information-messages/get-generated-note';
import { getMessageLanguages } from '../fn/information-messages/get-message-languages';
import { GetMessageLanguages$Params } from '../fn/information-messages/get-message-languages';
import { getNews } from '../fn/information-messages/get-news';
import { GetNews$Params } from '../fn/information-messages/get-news';
import { getTriggers } from '../fn/information-messages/get-triggers';
import { GetTriggers$Params } from '../fn/information-messages/get-triggers';
import { getTriggerTargets } from '../fn/information-messages/get-trigger-targets';
import { GetTriggerTargets$Params } from '../fn/information-messages/get-trigger-targets';
import { getTriggerVariables } from '../fn/information-messages/get-trigger-variables';
import { GetTriggerVariables$Params } from '../fn/information-messages/get-trigger-variables';
import { joinNewsFiles } from '../fn/information-messages/join-news-files';
import { JoinNewsFiles$Params } from '../fn/information-messages/join-news-files';
import { listNews } from '../fn/information-messages/list-news';
import { ListNews$Params } from '../fn/information-messages/list-news';
import { MessageLanguageOptions } from '../models/message-language-options';
import { News } from '../models/news';
import { NewsListPaged } from '../models/news-list-paged';
import { readGeneratedNoteByLoggedUser } from '../fn/information-messages/read-generated-note-by-logged-user';
import { ReadGeneratedNoteByLoggedUser$Params } from '../fn/information-messages/read-generated-note-by-logged-user';
import { searchConfiguredMessages$Any } from '../fn/information-messages/search-configured-messages-any';
import { SearchConfiguredMessages$Any$Params } from '../fn/information-messages/search-configured-messages-any';
import { searchConfiguredMessages$Json } from '../fn/information-messages/search-configured-messages-json';
import { SearchConfiguredMessages$Json$Params } from '../fn/information-messages/search-configured-messages-json';
import { searchGeneratedNotesAll } from '../fn/information-messages/search-generated-notes-all';
import { SearchGeneratedNotesAll$Params } from '../fn/information-messages/search-generated-notes-all';
import { searchLuceneGeneratedNotesAll } from '../fn/information-messages/search-lucene-generated-notes-all';
import { SearchLuceneGeneratedNotesAll$Params } from '../fn/information-messages/search-lucene-generated-notes-all';
import { TriggerTargetList } from '../models/trigger-target-list';
import { TriggerVariableList } from '../models/trigger-variable-list';
import { updateConfiguredMessage } from '../fn/information-messages/update-configured-message';
import { UpdateConfiguredMessage$Params } from '../fn/information-messages/update-configured-message';
import { updateNews } from '../fn/information-messages/update-news';
import { UpdateNews$Params } from '../fn/information-messages/update-news';


/**
 * All about the configuration and retrieval of information messages
 */
@Injectable({ providedIn: 'root' })
export class InformationMessagesService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createConfiguredMessage()` */
  static readonly CreateConfiguredMessagePath = '/messages-configured';

  /**
   * Create a configured message with note and notifications.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createConfiguredMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createConfiguredMessage$Response(params: CreateConfiguredMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createConfiguredMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a configured message with note and notifications.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createConfiguredMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createConfiguredMessage(params: CreateConfiguredMessage$Params, context?: HttpContext): Observable<void> {
    return this.createConfiguredMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchConfiguredMessages()` */
  static readonly SearchConfiguredMessagesPath = '/messages-configured/search';

  /**
   * Search configured messages, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchConfiguredMessages$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchConfiguredMessages$Json$Response(params?: SearchConfiguredMessages$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfiguredMessageListPaged>> {
    return searchConfiguredMessages$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search configured messages, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchConfiguredMessages$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchConfiguredMessages$Json(params?: SearchConfiguredMessages$Json$Params, context?: HttpContext): Observable<ConfiguredMessageListPaged> {
    return this.searchConfiguredMessages$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfiguredMessageListPaged>): ConfiguredMessageListPaged => r.body)
    );
  }

  /**
   * Search configured messages, with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchConfiguredMessages$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchConfiguredMessages$Any$Response(params?: SearchConfiguredMessages$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfiguredMessageListPaged>> {
    return searchConfiguredMessages$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search configured messages, with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchConfiguredMessages$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchConfiguredMessages$Any(params?: SearchConfiguredMessages$Any$Params, context?: HttpContext): Observable<ConfiguredMessageListPaged> {
    return this.searchConfiguredMessages$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfiguredMessageListPaged>): ConfiguredMessageListPaged => r.body)
    );
  }

  /** Path part for operation `getConfiguredMessage()` */
  static readonly GetConfiguredMessagePath = '/messages-configured/{uid}';

  /**
   * Retrieve a configured message.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfiguredMessage()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfiguredMessage$Response(params: GetConfiguredMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfiguredMessage>> {
    return getConfiguredMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a configured message.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfiguredMessage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfiguredMessage(params: GetConfiguredMessage$Params, context?: HttpContext): Observable<ConfiguredMessage> {
    return this.getConfiguredMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfiguredMessage>): ConfiguredMessage => r.body)
    );
  }

  /** Path part for operation `updateConfiguredMessage()` */
  static readonly UpdateConfiguredMessagePath = '/messages-configured/{uid}';

  /**
   * Update a configured message.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateConfiguredMessage()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateConfiguredMessage$Response(params: UpdateConfiguredMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateConfiguredMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a configured message.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateConfiguredMessage$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateConfiguredMessage(params: UpdateConfiguredMessage$Params, context?: HttpContext): Observable<void> {
    return this.updateConfiguredMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteConfiguredMessage()` */
  static readonly DeleteConfiguredMessagePath = '/messages-configured/{uid}';

  /**
   * Delete a configured message.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteConfiguredMessage()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteConfiguredMessage$Response(params: DeleteConfiguredMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteConfiguredMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a configured message.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteConfiguredMessage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteConfiguredMessage(params: DeleteConfiguredMessage$Params, context?: HttpContext): Observable<void> {
    return this.deleteConfiguredMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getTriggers()` */
  static readonly GetTriggersPath = '/messages/triggers';

  /**
   * Retrieve the list of available triggers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTriggers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTriggers$Response(params?: GetTriggers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getTriggers(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve the list of available triggers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTriggers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTriggers(params?: GetTriggers$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getTriggers$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `getMessageLanguages()` */
  static readonly GetMessageLanguagesPath = '/messages/languages';

  /**
   * Retrieve the list of available languages.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMessageLanguages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMessageLanguages$Response(params?: GetMessageLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<MessageLanguageOptions>> {
    return getMessageLanguages(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve the list of available languages.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMessageLanguages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMessageLanguages(params?: GetMessageLanguages$Params, context?: HttpContext): Observable<MessageLanguageOptions> {
    return this.getMessageLanguages$Response(params, context).pipe(
      map((r: StrictHttpResponse<MessageLanguageOptions>): MessageLanguageOptions => r.body)
    );
  }

  /** Path part for operation `getTriggerVariables()` */
  static readonly GetTriggerVariablesPath = '/messages/triggers/{trigger}/variables';

  /**
   * Retrieve a list of variables for use in a message's content, depending on the trigger chosen.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTriggerVariables()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTriggerVariables$Response(params: GetTriggerVariables$Params, context?: HttpContext): Observable<StrictHttpResponse<TriggerVariableList>> {
    return getTriggerVariables(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of variables for use in a message's content, depending on the trigger chosen.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTriggerVariables$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTriggerVariables(params: GetTriggerVariables$Params, context?: HttpContext): Observable<TriggerVariableList> {
    return this.getTriggerVariables$Response(params, context).pipe(
      map((r: StrictHttpResponse<TriggerVariableList>): TriggerVariableList => r.body)
    );
  }

  /** Path part for operation `getTriggerTargets()` */
  static readonly GetTriggerTargetsPath = '/messages/triggers/{trigger}/targets';

  /**
   * Retrieve a list of dynamic user target that can be used for this trigger.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTriggerTargets()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTriggerTargets$Response(params: GetTriggerTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<TriggerTargetList>> {
    return getTriggerTargets(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieve a list of dynamic user target that can be used for this trigger.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTriggerTargets$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTriggerTargets(params: GetTriggerTargets$Params, context?: HttpContext): Observable<TriggerTargetList> {
    return this.getTriggerTargets$Response(params, context).pipe(
      map((r: StrictHttpResponse<TriggerTargetList>): TriggerTargetList => r.body)
    );
  }

  /** Path part for operation `searchLuceneGeneratedNotesAll()` */
  static readonly SearchLuceneGeneratedNotesAllPath = '/notes-generated/search';

  /**
   * search notes-generated.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchLuceneGeneratedNotesAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchLuceneGeneratedNotesAll$Response(params?: SearchLuceneGeneratedNotesAll$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneratedNotePagedListAdmin>> {
    return searchLuceneGeneratedNotesAll(this.http, this.rootUrl, params, context);
  }

  /**
   * search notes-generated.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchLuceneGeneratedNotesAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchLuceneGeneratedNotesAll(params?: SearchLuceneGeneratedNotesAll$Params, context?: HttpContext): Observable<GeneratedNotePagedListAdmin> {
    return this.searchLuceneGeneratedNotesAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneratedNotePagedListAdmin>): GeneratedNotePagedListAdmin => r.body)
    );
  }

  /** Path part for operation `searchGeneratedNotesAll()` */
  static readonly SearchGeneratedNotesAllPath = '/notes-generated';

  /**
   * Get all generated notes, with pagination, admin only.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchGeneratedNotesAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchGeneratedNotesAll$Response(params?: SearchGeneratedNotesAll$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneratedNotePagedListAdmin>> {
    return searchGeneratedNotesAll(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all generated notes, with pagination, admin only.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchGeneratedNotesAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  searchGeneratedNotesAll(params?: SearchGeneratedNotesAll$Params, context?: HttpContext): Observable<GeneratedNotePagedListAdmin> {
    return this.searchGeneratedNotesAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneratedNotePagedListAdmin>): GeneratedNotePagedListAdmin => r.body)
    );
  }

  /** Path part for operation `getGeneratedNote()` */
  static readonly GetGeneratedNotePath = '/notes-generated/{uid}';

  /**
   * Get a single generated note.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getGeneratedNote()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGeneratedNote$Response(params: GetGeneratedNote$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneratedNote>> {
    return getGeneratedNote(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a single generated note.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getGeneratedNote$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getGeneratedNote(params: GetGeneratedNote$Params, context?: HttpContext): Observable<GeneratedNote> {
    return this.getGeneratedNote$Response(params, context).pipe(
      map((r: StrictHttpResponse<GeneratedNote>): GeneratedNote => r.body)
    );
  }

  /** Path part for operation `readGeneratedNoteByLoggedUser()` */
  static readonly ReadGeneratedNoteByLoggedUserPath = '/notes-generated/{uid}/read-by-logged-user';

  /**
   * Indicates that the logged user read this note.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `readGeneratedNoteByLoggedUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  readGeneratedNoteByLoggedUser$Response(params: ReadGeneratedNoteByLoggedUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return readGeneratedNoteByLoggedUser(this.http, this.rootUrl, params, context);
  }

  /**
   * Indicates that the logged user read this note.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `readGeneratedNoteByLoggedUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  readGeneratedNoteByLoggedUser(params: ReadGeneratedNoteByLoggedUser$Params, context?: HttpContext): Observable<void> {
    return this.readGeneratedNoteByLoggedUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listNews()` */
  static readonly ListNewsPath = '/news';

  /**
   * Get all news, planned or already sent or both.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listNews()` instead.
   *
   * This method doesn't expect any request body.
   */
  listNews$Response(params?: ListNews$Params, context?: HttpContext): Observable<StrictHttpResponse<NewsListPaged>> {
    return listNews(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all news, planned or already sent or both.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listNews$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listNews(params?: ListNews$Params, context?: HttpContext): Observable<NewsListPaged> {
    return this.listNews$Response(params, context).pipe(
      map((r: StrictHttpResponse<NewsListPaged>): NewsListPaged => r.body)
    );
  }

  /** Path part for operation `createNews()` */
  static readonly CreateNewsPath = '/news';

  /**
   * Directly generate a message, used for news.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createNews()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createNews$Response(params: CreateNews$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createNews(this.http, this.rootUrl, params, context);
  }

  /**
   * Directly generate a message, used for news.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createNews$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createNews(params: CreateNews$Params, context?: HttpContext): Observable<void> {
    return this.createNews$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getNews()` */
  static readonly GetNewsPath = '/news/{uid}';

  /**
   * Get a single news.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNews()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNews$Response(params: GetNews$Params, context?: HttpContext): Observable<StrictHttpResponse<News>> {
    return getNews(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a single news.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNews$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNews(params: GetNews$Params, context?: HttpContext): Observable<News> {
    return this.getNews$Response(params, context).pipe(
      map((r: StrictHttpResponse<News>): News => r.body)
    );
  }

  /** Path part for operation `updateNews()` */
  static readonly UpdateNewsPath = '/news/{uid}';

  /**
   * Update a news, a news can be re-planned by changing the plannedDate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateNews()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateNews$Response(params: UpdateNews$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateNews(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a news, a news can be re-planned by changing the plannedDate.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateNews$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateNews(params: UpdateNews$Params, context?: HttpContext): Observable<void> {
    return this.updateNews$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteNews()` */
  static readonly DeleteNewsPath = '/news/{uid}';

  /**
   * Delete a news, only useful if the news was not already sent and you want to cancel it.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteNews()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteNews$Response(params: DeleteNews$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteNews(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a news, only useful if the news was not already sent and you want to cancel it.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteNews$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteNews(params: DeleteNews$Params, context?: HttpContext): Observable<void> {
    return this.deleteNews$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `joinNewsFiles()` */
  static readonly JoinNewsFilesPath = '/news/file';

  /**
   * Join files, used for news.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `joinNewsFiles()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  joinNewsFiles$Response(params?: JoinNewsFiles$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return joinNewsFiles(this.http, this.rootUrl, params, context);
  }

  /**
   * Join files, used for news.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `joinNewsFiles$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  joinNewsFiles(params?: JoinNewsFiles$Params, context?: HttpContext): Observable<void> {
    return this.joinNewsFiles$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
